import { Button, Tooltip } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useResourceInvalidate } from "@/hooks";

export const RefreshButton = ({ resource, id, onClick }) => {
  const { t } = useTranslation();
  const invalidate = useResourceInvalidate();
  return (
    <Tooltip title={t("actions.refresh")}>
      <Button
        shape="circle"
        icon={<ReloadOutlined />}
        onClick={() => {
          if (onClick) {
            onClick();
          } else if (id) {
            invalidate({
              resource,
              id,
              invalidates: ["detail"],
            });
          }
        }}
      />
    </Tooltip>
  );
};
